<template>
  <el-card>
    <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('名称')" prop="name">
        <el-input :placeholder="$t('名称')" v-model="formData.name" />
      </el-form-item>

      <el-form-item :label="$t('内容')" class="rich-text-row" prop="content">
        <wangeditor ref="editor" v-model="formData.content" :upload-img-server="$api.file.uploadEditor" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{$t('确定')}}</el-button>
        <el-button @click="resetForm">{{$t('取消')}}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
import {resetEmpty} from "@/utils/common";
import {request} from "@/config/request";
export default {
  name: "RichTextAdd",
  components: {Wangeditor},
  data() {
    return {
      formData:  {
        name: "",
        content: "",
      },
      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        content: {required: true, message: this.$t('请输入内容'), trigger: 'blur'}
      }
    }
  },
  methods: {
    // 提交
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          await request(this.$api.richText.add, this.formData);
          this.$message.success(this.$t('操作成功'));
          this.$router.back();
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.$refs.editor.clear();
    }
  }
}
</script>

<style scoped>

.el-form {
  max-width: 400px;
}

.rich-text-row {
  width: 900px;
}

</style>
